import resume from '../assets/pdf/resume.pdf'
import  Aftab  from '../jpg/Aftab2.jpg'
export const headerData = {
    name: 'Aftab Ahmed',
    title: "Full-Stack Web Developer",
    desciption:"MERN Full-stack web developer, known for my innovative approach to problem-solving and delivering top-quality results in a fast-paced environment.",
    image: Aftab,
    resumePdf: resume
}
